import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  currentPage: 1,
  currentPageSize: 10,
  sortBy: "",
  sortOrder: "",
  search: "",
  clearSelection: false,
  showBulkUpload: false,
};

const certificateUploadSlice = createSlice({
  name: "certificateUpload",
  initialState,
  reducers: {
    updateConfig: (state, action) => {
      action.payload(state);
    },
  },
});

export const { updateConfig } = certificateUploadSlice.actions;

export default certificateUploadSlice.reducer;
